import { toEN } from 'utils/date.util'
import { selectFieldSchema } from 'utils/schema.util'
import { hasNumbers, isCnj, isDate, validateField } from 'utils/validate.util'
import { z } from 'zod'
import {
  ERROR_MESSAGE,
  ERROR_MESSAGE_CNJ_INCORRECT,
  ERROR_MESSAGE_NUMBERS_IN_STRING,
} from './error.type'

export const hearingGeneralDataSchema = z
  .object({
    adolescenteApreendido: z
      .preprocess((field) => {
        return validateField(field)
      }, z.string())
      .refine((field) => field === 'S' || field === 'N', {
        message: ERROR_MESSAGE,
      }),
    craai: z
      .string({
        required_error: ERROR_MESSAGE,
      })
      .refine((field) => field !== '0', { message: ERROR_MESSAGE }),
    dataOitiva: z
      .string({
        required_error: ERROR_MESSAGE,
      })
      .refine(
        (field) => {
          return isDate(field)
        },
        {
          message: ERROR_MESSAGE,
        },
      )
      .transform((field) => {
        return toEN(field)
      }),
    idPromotoria: selectFieldSchema,
    descricaoIdPromotoria: z.preprocess((field) => {
      return validateField(field)
    }, z.string()),
    nomeAdvogado: z
      .preprocess((field) => {
        return validateField(field)
      }, z.string())
      .refine((field) => !hasNumbers(field), {
        message: ERROR_MESSAGE_NUMBERS_IN_STRING,
      }),
    nomeResponsavelAdolescente: z
      .preprocess((field) => {
        return validateField(field)
      }, z.string())
      .refine((field) => !hasNumbers(field), {
        message: ERROR_MESSAGE_NUMBERS_IN_STRING,
      }),
    numeroAaaPai: z.preprocess((field) => {
      return validateField(field)
    }, z.string()),
    numeroAiai: z.preprocess((field) => {
      return validateField(field)
    }, z.string()),
    numeroCnj: z
      .string({
        required_error: ERROR_MESSAGE,
      })
      .min(1, ERROR_MESSAGE)
      .refine((field) => isCnj(field), {
        message: ERROR_MESSAGE_CNJ_INCORRECT,
      }),
    numeroOabDefensor: z.preprocess((field) => {
      return validateField(field)
    }, z.string()),
  })
  .superRefine((fields, ctx) => {
    if (
      fields.adolescenteApreendido &&
      fields.adolescenteApreendido === 'S' &&
      fields.numeroAaaPai === ''
    ) {
      ctx.addIssue({
        path: ['numeroAaaPai'],
        code: z.ZodIssueCode.custom,
        message: ERROR_MESSAGE,
      })
    }
  })
  .superRefine((fields, ctx) => {
    if (
      fields.adolescenteApreendido &&
      fields.adolescenteApreendido === 'N' &&
      fields.numeroAiai === ''
    ) {
      ctx.addIssue({
        path: ['numeroAiai'],
        code: z.ZodIssueCode.custom,
        message: ERROR_MESSAGE,
      })
    }
  })

export type HearingGeneralDataType = z.infer<typeof hearingGeneralDataSchema>

export const hearingGeneralDataInit: HearingGeneralDataType = {
  adolescenteApreendido: '',
  craai: '0',
  dataOitiva: '',
  descricaoIdPromotoria: '',
  idPromotoria: '0',
  nomeAdvogado: '',
  nomeResponsavelAdolescente: '',
  numeroAaaPai: '',
  numeroAiai: '',
  numeroCnj: '',
  numeroOabDefensor: '',
}
